import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { usePathname } from 'next/navigation';
import { useGetTenantNameByHostnameQuery } from '@cntxt/data-access/user';
import { isRegisteredKeycloakTenantId } from '@cntxt/shared/infrastructure/keycloak';
import { isAuthPage, signIn, useIsSigningOut, useSession } from '@cntxt/shared/infrastructure/session';
import { Loading } from '@cntxt/shared/ui/feedback';
import { useHostname } from '@cntxt/shared/utilities/hooks';
import { getOAuthRedirectTargetUrl } from '../lib/getOAuthRedirectTargetUrl';
import { reportUnexpectedSignInRejection } from '../lib/signInExpectedFetchAbort';
import { useSignInLoopGuard } from '../lib/useSignInLoopGuard';
import { SignInBlockedAlert } from './SignInBlockedAlert';
export function AuthProvider(t0) {
  const $ = _c(16);
  const {
    children
  } = t0;
  const {
    status
  } = useSession();
  const isSigningOut = useIsSigningOut();
  const pathname = usePathname();
  const [showChildren, setShowChildren] = React.useState(false);
  const [unknownProvider, setUnknownProvider] = React.useState(false);
  const {
    allowSignIn,
    markSignedIn
  } = useSignInLoopGuard();
  const hostname = useHostname();
  let t1;
  if ($[0] !== hostname) {
    t1 = {
      hostname
    };
    $[0] = hostname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: provider,
    isError: tenantLookupFailed
  } = useGetTenantNameByHostnameQuery(t1);
  let t2;
  let t3;
  if ($[2] !== allowSignIn || $[3] !== markSignedIn || $[4] !== pathname || $[5] !== provider || $[6] !== status) {
    t2 = () => {
      if (!status || !pathname) {
        return;
      }
      if (status === "loading") {
        return;
      }
      if (status === "authenticated") {
        markSignedIn();
        setUnknownProvider(false);
        setShowChildren(true);
        return;
      }
      if (isAuthPage(pathname)) {
        setUnknownProvider(false);
        setShowChildren(true);
        return;
      }
      if (typeof provider === "string") {
        if (!isRegisteredKeycloakTenantId(provider)) {
          setUnknownProvider(true);
          return;
        }
        setUnknownProvider(false);
        if (!allowSignIn()) {
          return;
        }
        signIn(provider, {
          redirectTo: getOAuthRedirectTargetUrl()
        }).catch(_temp);
        return;
      }
      setUnknownProvider(false);
    };
    t3 = [status, pathname, provider, allowSignIn, markSignedIn];
    $[2] = allowSignIn;
    $[3] = markSignedIn;
    $[4] = pathname;
    $[5] = provider;
    $[6] = status;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  React.useEffect(t2, t3);
  if (isSigningOut) {
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Loading fullScreen={true} source="AuthProvider" />;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  if (tenantLookupFailed) {
    let t4;
    if ($[10] !== hostname) {
      t4 = <SignInBlockedAlert variant="tenant_hostname_lookup_failed" hostname={hostname} context="AuthProvider" layout="appShell" />;
      $[10] = hostname;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    return t4;
  }
  if (unknownProvider && typeof provider === "string") {
    let t4;
    if ($[12] !== hostname || $[13] !== provider) {
      t4 = <SignInBlockedAlert variant="tenant_not_in_keycloak_allowlist" hostname={hostname} resolvedTenantId={provider} context="AuthProvider" layout="appShell" />;
      $[12] = hostname;
      $[13] = provider;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    return t4;
  }
  const sessionGone = status === "unauthenticated" && Boolean(pathname) && !isAuthPage(pathname);
  if (showChildren && !sessionGone) {
    return children;
  }
  let t4;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Loading fullScreen={true} source="AuthProvider" />;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}
function _temp(error) {
  reportUnexpectedSignInRejection("AuthProvider", error);
}